const getHcKeys = (dealHCKey: string): string[] => {
  const [countryHCKeyPart = "", stateHCKeyPart = "", countyHCKeyPart = ""] = dealHCKey.split("-");

  const countryHCKey = countryHCKeyPart;
  const stateHCKey = [countryHCKeyPart, stateHCKeyPart].join("-");
  const countyHCKey = [countryHCKeyPart, stateHCKeyPart, countyHCKeyPart].join("-");

  return [countryHCKey, stateHCKey, countyHCKey];
};

export default getHcKeys;
